import { useGetAllCourierPartnersQuery } from "../../../redux/commonRTK";

function useGetCourier() {
    const requestPayload = {
        andfilter: [{ "field": "is_deleted", "operator": "eq", "value": '0' }, { "field": "supported_shipment", "operator": "eq", "value": "B2C" }, { "field": "isActive", "operator": "eq", "value": true }, { "field": "isExternal", "operator": "eq", "value": false }],
        offset: 0,
        limit: 500,
        includes: "id,name,parent,prozoId,cpAccountCode"
    }

    return useGetAllCourierPartnersQuery(requestPayload)
}

export default useGetCourier;